import { FileManager } from '../../components/file-manager';

export const MediaList: React.FC = () => (
    <div style={{ height: '400px', marginBottom: '20px' }}>
        <FileManager
            config={{
                multiple: true,
                showPreview: true,
                showMetadata: true,
                enableDragDrop: true,
            }}
            hasDeleteMany
        />
    </div>
);
